import { useListOrder } from '../../filter';
import { WorkspaceOrderKey } from '../domain';

export const useWorkspaceListOrder = () => {
  return useListOrder(WorkspaceOrderKey, 'workspaceOrderBy');
};
